/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { environment } from '../../../../environments/environment';

export const defaultNavigation: FuseNavigationItem[] = [
    // Main navigation items
    {
        id: 'sync',
        title: '',
        tooltip: 'navigation.sync',
        type: 'basic',
        icon: 'heroicons_outline:phone',
        link: '/sync',
        meta: {
            requiresWorkspaceRoles: ['admin', 'configurator'],
        },
    },
    {
        id: 'chat',
        title: '',
        tooltip: 'navigation.chat',
        type: 'basic',
        icon: 'heroicons_outline:chat-bubble-left-right',
        link: '/chat',
        meta: {
            requiresWorkspaceRoles: ['admin', 'supervisor', 'agent'],
        },
    },
    {
        id: 'api-keys',
        title: '',
        tooltip: 'navigation.apiKeys',
        type: 'basic',
        icon: 'heroicons_outline:key',
        link: '/api-keys',
        meta: {
            requiresWorkspaceRoles: ['admin', 'configurator'],
        },
    },
    {
        id: 'quick-replies',
        title: '',
        tooltip: 'navigation.quickReplies',
        type: 'basic',
        icon: 'heroicons_outline:bolt',
        link: '/quick-replies',
        meta: {
            // Management page. Agents consume quick replies from the chat
            // input (separate flow), so they don't need the navbar entry.
            requiresWorkspaceRoles: ['admin', 'supervisor'],
        },
    },
    {
        id: 'saved-filters',
        title: '',
        tooltip: 'navigation.savedFilters',
        type: 'basic',
        icon: 'heroicons_outline:bookmark',
        link: '/saved-filters',
        meta: {
            // Agents manage their own saved filters, so unlike quick replies the
            // entry is theirs too. configurator never reaches the chat.
            requiresWorkspaceRoles: ['admin', 'supervisor', 'agent'],
        },
    },
    {
        id: 'tags',
        title: '',
        tooltip: 'navigation.tags',
        type: 'basic',
        icon: 'heroicons_outline:tag',
        link: '/tags',
        meta: {
            // Every member may read the vocabulary; only admins can change it
            // (enforced in the component, not the route).
            requiresWorkspaceRoles: [
                'admin',
                'supervisor',
                'configurator',
                'agent',
            ],
        },
    },
    {
        id: 'webhook-events',
        title: '',
        tooltip: 'navigation.webhookEvents',
        type: 'basic',
        icon: 'heroicons_outline:arrow-up-on-square-stack',
        link: '/webhook-events',
        meta: {
            requiresWorkspaceRoles: ['admin', 'configurator'],
        },
    },
    {
        id: 'workspace-users',
        title: '',
        tooltip: 'navigation.workspaceUsers',
        type: 'basic',
        icon: 'heroicons_outline:user-group',
        link: '/workspaces',
        meta: {
            requiresWorkspaceRoles: ['admin'],
            dynamicWorkspaceLink: '/users',
        },
    },
    {
        id: 'queues',
        title: '',
        tooltip: 'navigation.queues',
        type: 'basic',
        icon: 'custom:attention-queue',
        link: '/queues',
        meta: {
            requiresWorkspaceRoles: ['admin', 'supervisor'],
        },
    },
    {
        id: 'message-quota',
        title: '',
        tooltip: 'navigation.messageQuota',
        type: 'basic',
        icon: 'heroicons_outline:no-symbol',
        link: '/message-quota',
        meta: {
            // Any member may read the settings and release a blocked conversation;
            // only admins can save (enforced in the form, not the route).
            requiresWorkspaceRoles: [
                'admin',
                'supervisor',
                'configurator',
                'agent',
            ],
        },
    },
    {
        id: 'analytics',
        title: '',
        tooltip: 'navigation.analytics',
        type: 'basic',
        icon: 'heroicons_outline:chart-bar',
        link: '/analytics',
        meta: {
            requiresWorkspaceRoles: ['admin', 'supervisor'],
        },
    },
    {
        id: 'workspace-settings',
        title: '',
        tooltip: 'navigation.workspaceSettings',
        type: 'basic',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/workspace-settings',
        meta: {
            // The timezone regroups every analytics figure; only workspace admins set it.
            requiresWorkspaceRoles: ['admin'],
        },
    },
    {
        id: 'api-docs',
        title: '',
        tooltip: 'navigation.apiDocs',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: `${environment.api.baseUrl}/${environment.api.version}/api/docs`,
        target: '_blank',
        externalLink: true,
        meta: {
            // Swagger is for whoever integrates against the API; agents work in the
            // chat and have no use for the endpoint reference.
            requiresWorkspaceRoles: ['admin', 'supervisor', 'configurator'],
        },
    },
    // Spacer to push admin items to the right
    {
        id: 'spacer',
        type: 'spacer',
    },
    // Administration items (positioned at right)
    {
        id: 'users',
        title: '',
        tooltip: 'navigation.users',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
        meta: {
            requiredRole: 'admin',
        },
    },
    {
        id: 'workspaces',
        title: '',
        tooltip: 'navigation.workspaces',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/workspaces',
        // Exact: the nav matches by prefix by default, so the list item stayed lit
        // on '/workspaces/:id/users', which is the workspace-users item's route.
        exactMatch: true,
        meta: {
            requiredRole: 'admin',
        },
    },
];

export const compactNavigation: FuseNavigationItem[] = defaultNavigation;
export const futuristicNavigation: FuseNavigationItem[] = defaultNavigation;
export const horizontalNavigation: FuseNavigationItem[] = defaultNavigation;
